import { InMemoryCache } from '@apollo/client';
import { MappedArtist } from 'typings/talent';
import { GET_MAPPED_PROFILES } from 'graphqls/profile';

export const initializeMappedProfiles = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_MAPPED_PROFILES,
    data: {},
  });
};

export default {
  resolvers: {
    Mutation: {
      setMappedProfiles: (_, data, { cache }): { setMappedProfiles: Array<MappedArtist> } => {
        cache.writeQuery({
          query: GET_MAPPED_PROFILES,
          data: {
            mappedProfiles: {
              __typename: 'mappedArtists',
              data: data.data,
            },
          },
        });

        return data.data;
      },
    },
  },
};
